import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineSearch } from 'react-icons/ai';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { Bs1CircleFill } from 'react-icons/bs';
import UserLogo from '../../assets/user-logo.png';
import { MdManageAccounts } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';


const OfflineReportCard = ({ setLoading }) => {
  const [classes, setClasses] = useState([]);
  const [std, setStd] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
    // const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [searchTerm, setSearchTerm] = useState('');
const navigate = useNavigate();



  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetches for classes and academic years
  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
    //  const currentAY = new Date().getFullYear();

    //    if (currentAY) {
    //     setSelectedAY(currentAY);
    //     fetchStudents(currentAY);
    //   }
  }, []);
  


  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);


  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }
     fetchStudents(selectedAY, selectedClassId, selectedSection);
  };


   const fetchStudents = async (ay, classId, section = '') => {
    setLoading(true);
    try {
      const selectedClass = classes.find((cls) => cls.id === Number(classId));
      const className = selectedClass ? selectedClass.class_name : '';

      const params = new URLSearchParams();
      params.append('ay', ay);
      params.append('class_name', className);
      if (section) params.append('section', section);

      const url = `https://api.kcian.in/get-student?${params.toString()}`;
      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


            const handlePrepare = (std) => {
                  navigate("/admin/prepare-report-card", {
    state: {
      student: std,
    },
  });
  }


const filteredStd = std.filter(student => {
  const term = searchTerm.toLowerCase();
  const name = student.name ? student.name.toLowerCase() : '';
  const regNo = student.reg_no ? student.reg_no.toLowerCase() : '';
  return name.includes(term) || regNo.includes(term);
});



  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Exam' message2='Report Card' />

          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>

          <div className='profile-card mt-4'>

            <div className='d-md-flex d-sm-flex justify-content-between'>
            <span className="profile-heading align-content-center">Student List</span>

                              <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
            </div>
            {/* Render student list here */}
       {/* {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />} */}

            <div className='table-responsive mt-3'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Roll No</th>
    <th>Admission No</th>
    <th>Name</th>
    <th>DOB</th>
    <th>Class(Section)</th>
    <th>Father's Name</th>
    <th>Mother's Name</th>
    <th className='rounded-end-4'>Activity</th>
</thead>


            {std.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
            ) : (
              <>
                {filteredStd.map((student) => (
  <tr className='account-tr' key={student.id}>
    <td>{student.roll_no}</td>
    <td>{student.admission_no}</td>
    <td>{student.name}</td>
    <td>{student.dob || '--'}</td>
<td>{student.class_name}({student.section})</td>
    <td>{student.father || '--'}</td>
    <td>{student.mother || '--'}</td>
<td>        <MdManageAccounts className='emp-icon bg-purple' title='Prepare Report Card' onClick={() => handlePrepare(student)} />
</td>


                    </tr>
                ))}
              </>
            )}

</table>
</div>
{/* table ends */}

          </div>
        </div>
      </section>


    </>
  );
};

export default OfflineReportCard;
